// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:38:45

export default {
  "id": "disk-rush",
  "slug": "disk-rush",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0d96baffb814444d8c66820ef72633ab-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0d96baffb814444d8c66820ef72633ab/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Disk Rush",
      "description": "Disk Rush is a reaction-based arcade game where players must quickly sort colored disks into their matching zones. The game challenges your speed and accuracy as disks appear faster over time. With simple tap mechanics and increasing difficulty, Disk Rush tests your ability to think and act quickly under pressure.  ",
      "instructions": "1. Watch the color of the incoming disk.  \n2. Tap the correct side of the screen to send it to the matching zone.  \n3. Be quick—disks appear faster as the game progresses!  \n4. Sorting incorrectly ends the game, so stay focused.  \n5. Keep playing to beat your high score!",
      "genres": [
        "Casual"
      ],
      "tags": [
        "color",
        "skill",
        "speed"
      ]
    },
    "zh-CN": {
      "title": "磁盘冲刺",
      "description": "《磁盘冲刺》是一款基于反应的街机游戏，玩家必须迅速将彩色磁盘分类到对应的区域。游戏挑战你的速度和准确性，因为随着时间的推移，磁盘出现的速度会越来越快。凭借简单的点击机制和不断增加的难度，《磁盘冲刺》考验你在压力下快速思考和行动的能力。",
      "instructions": "1. 观察即将到来的圆盘的颜色。\n2. 点击屏幕的正确一侧将其发送到匹配区域。\n3. 要快——随着游戏进行，圆盘出现得更快！\n4. 分类错误会结束游戏，所以保持专注。\n5. 继续玩以打破你的最高分！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "颜色",
        "技能",
        "速度"
      ]
    },
    "zh-TW": {
      "title": "磁碟突擊",
      "description": "《Disk Rush》是一款基於反應的街機遊戲，玩家必須快速將彩色碟片分類到對應的區域。隨著時間推移，碟片出現的速度會變快，遊戲挑戰你的速度和準確性。憑藉簡單的點擊機制和逐漸增加的難度，《Disk Rush》考驗你在壓力下快速思考和行動的能力。",
      "instructions": "1. 注意進來的碟片顏色。\n2. 點擊螢幕正確的一側將其傳送到匹配區域。\n3. 要快——隨著遊戲進行，碟片出現的速度會變快！\n4. 分類錯誤會結束遊戲，所以要保持專注。\n5. 繼續玩以打破你的最高分數！",
      "genres": [
        "休閒"
      ],
      "tags": [
        "顏色",
        "技能",
        "速度"
      ]
    },
    "zh-HK": {
      "title": "硬碟衝擊",
      "description": "《碟片衝擊》是一款基於反應的街機遊戲，玩家必須迅速將彩色碟片分類到相應的區域。隨著時間推移，碟片出現的速度會變快，遊戲挑戰你的速度和準確性。憑藉簡單的點擊機制和逐漸增加的難度，《碟片衝擊》考驗你在壓力下快速思考和行動的能力。",
      "instructions": "1. 留意進來碟片的顏色。\n2. 點擊屏幕正確的一側，將其送到匹配區域。\n3. 要快—隨著遊戲進行，碟片出現的速度會變快！\n4. 分類錯誤會結束遊戲，所以要專注。\n5. 繼續玩以打破你的最高分數！",
      "genres": [
        "休閒"
      ],
      "tags": [
        "顏色",
        "技能",
        "速度"
      ]
    },
    "ja": {
      "title": "ディスクラッシュ",
      "description": "ディスクラッシュは反射神経を要するアーケードゲームで、プレイヤーは色とりどりのディスクを迅速に対応するゾーンに分類しなければなりません。ゲームは、ディスクが時間とともに速く出現するにつれて、あなたのスピードと精度に挑戦します。シンプルなタップメカニクスと難易度の上昇により、ディスクラッシュはプレッシャー下での迅速な思考と行動能力を試します。",
      "instructions": "1. 入ってくるディスクの色に注意してください。\n2. 正しい側の画面をタップして、一致するゾーンに送ってください。\n3. 迅速に！ゲームが進むにつれてディスクはより早く現れます！\n4. 間違った分類はゲーム終了となりますので、集中してください。\n5. 高得点を更新するためにプレイを続けてください！",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "色",
        "スキル",
        "スピード"
      ]
    },
    "ko": {
      "title": "디스크 러시",
      "description": "디스크 러시는 반응 속도를 기반으로 한 아케이드 게임으로, 플레이어는 컬러 디스크를 빠르게 일치하는 영역으로 정리해야 합니다. 게임은 시간이 지남에 따라 디스크가 더 빠르게 나타나며, 속도와 정확성을 시험합니다. 간단한 탭 메커니즘과 점점 어려워지는 난이도로, 디스크 러시는 압박감 속에서 빠르게 생각하고 행동하는 능력을 테스트합니다.",
      "instructions": "1. 들어오는 디스크의 색상을 주의하세요.\n2. 디스크를 일치하는 구역으로 보내기 위해 화면의 올바른 쪽을 탭하세요.\n3. 빠르게 하세요—게임이 진행될수록 디스크가 더 빠르게 나타납니다!\n4. 잘못 정렬하면 게임이 끝나니 집중하세요.\n5. 최고 점수를 깨기 위해 계속 플레이하세요!",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "색상",
        "스킬",
        "스피드"
      ]
    },
    "fr": {
      "title": "Disk Rush\n\n（注：这里假设\"Disk Rush\"可能是一个游戏的名称，因此不需要翻译，保持原名即可。如果需要表达“Disk Rush”或类似的游戏名称，通常不翻译，保持原名。\n\n请问您需要翻译的内容是什么？如果是“Disk Rush”这样的\": \"object\",\n        \"properties\": {\n  \"gameName\": \"Disk Rush\",\n  \"developer\": \"XYZ Studios\",\n  \"genre\": \"Action-Puzzle\",\n  \"platforms\": [\"PC\", \"PlayStation 4\", \"Xbox One通顺。\n- 继，则不必额外说明。\n\n```markdown\n# Disk\n```markdown\n# Disk Dash\n\n## 游戏概述\n《Disk Dash》是一款快节奏的休闲动作游戏，玩家需要控制一个旋转的磁盘，穿越充满障碍的关卡，同时收集金币和宝石，以获得高分。\n\n## 游戏特色\n\n- **独特的操控机制**：玩家\n1900",
      "description": "Disk Rush est un jeu d'arcade basé sur la réaction où les joueurs doivent rapidement trier des disques colorés dans leurs zones correspondantes. Le jeu met au défi votre vitesse et votre précision car les disques apparaissent de plus en plus vite au fil du temps. Avec des mécaniques de tap simples et une difficulté croissante, Disk Rush teste votre capacité à penser et à agir rapidement sous pression.",
      "instructions": "1. Observez la couleur du disque entrant.\n2. Tapez sur le côté correct de l'écran pour l'envoyer dans la zone correspondante.\n3. Soyez rapide—les disques apparaissent de plus en plus vite au fur et à mesure que le jeu progresse !\n4. Trier incorrectement met fin au jeu, alors restez concentré.\n5. Continuez à jouer pour battre votre meilleur score !",
      "genres": [
        "Décontracté"
      ],
      "tags": [
        "couleur",
        "compétence",
        "vitesse"
      ]
    }
  }
};
